import chakraTokenToVar from '@/utils/chakraTokenToVar'

export default {
  baseStyle: {
    tab: {
      color: 'fg',
      bg: 'bg',
      border: 'none',
      _selected: {
        borderBottom: `2px solid ${chakraTokenToVar('primary.solid')}`,
        color: 'primary.solid',
      },
    },
  },
}
